import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { DialogTitle, Grid, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Webcam from "react-webcam";

import PhotoCamera from "@material-ui/icons/PhotoCamera";

const WebcamCapture = (props) => {
  const webcamRef = React.useRef(null);

  const [imgSrc, setImgSrc] = React.useState(null);
  // eslint-disable-next-line no-unused-vars
  const [imgSrcSave, setImgSrcSave] = React.useState(null);
  const { data, onHandleChange } = props;

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
  }, [webcamRef, setImgSrc]);

  const saveImg = () => {
    setImgSrcSave(imgSrc);
    onHandleChange(data.selectedSalesData.id, imgSrc);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={5}>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            style={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={2} style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            // className={classes.button}
            startIcon={<PhotoCamera />}
            style={{ width: 180 }}
            onClick={capture}
          >
            {imgSrc ? "Retake Image" : "Capture Image"}
          </Button>
          <br />
          <br />
          {imgSrc && (
            <Button
              variant="contained"
              style={{ width: 180, background: "#008000", color: "white" }}
              // className={classes.button}

              onClick={saveImg}
            >
              Save
            </Button>
          )}
        </Grid>
        <Grid item xs={5}>
          {imgSrc && <img alt="img" src={imgSrc} />}
        </Grid>
      </Grid>
    </>
  );
};

WebcamCapture.propTypes = {
  onHandleChange: PropTypes.func,
  data: PropTypes.object,
};

WebcamCapture.defaultProps = {
  onHandleChange: (fn) => fn,
  data: {},
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 70,
    height: 35,
    textTransform: "capitalize",
    backgroundColor: "#245e9e",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const CaptureImageViewDialog = (props) => {
  const classes = useStyles();
  const { handleClose, open, data, onHandleChange } = props;

  return (
    <div>
      <Dialog
        maxWidth={"xl"}
        fullWidth
        open={open}
        disableBackdropClick
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <IconButton
            title="Close"
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.container}>
          <WebcamCapture data={data} onHandleChange={onHandleChange} />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
};

CaptureImageViewDialog.propTypes = {
  handleClose: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  data: PropTypes.object,
};

CaptureImageViewDialog.defaultProps = {
  handleClose: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  data: {},
};

export default CaptureImageViewDialog;
